import { css } from '@emotion/react';
import { SpacingToken } from '@livechat/design-system-react-components';

export const button = css`
  width: 209px;
  margin-bottom: var(${SpacingToken.Spacing2});
  justify-content: flex-start;
  gap: var(${SpacingToken.Spacing1});
  padding-right: var(${SpacingToken.Spacing3});
`;
